import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-donor',
  templateUrl: './dashboard-donor.component.html',
  styleUrls: ['./dashboard-donor.component.css']
})
export class DashboardDonorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
